import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaParrainageFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        accountId: [entity ? entity.accountId : null, Validators.required],
        gender: [entity ? entity.gender : null, Validators.required],
        firstname: [entity ? entity.firstname : null, Validators.required],
        lastname: [entity ? entity.lastname : null, Validators.required],
        email: [entity ? entity.email : null, Validators.required],
        number: [entity ? entity.number : null, Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      accountId: this.emptyIsNull(this.form.value.accountId),
      gender: this.emptyIsNull(this.form.value.gender),
      firstname: this.emptyIsNull(this.form.value.firstname),
      lastname: this.emptyIsNull(this.form.value.lastname),
      email: this.emptyIsNull(this.form.value.email),
      number: this.emptyIsNull(this.form.value.number),
    };
    return dto;
  }
}
